import React from "react";
import LeadsMonitoringLine from "./partial/LeadsMonitoringLine";
import { Spinner } from "reactstrap";

// Overlay shown on top of already-loaded content during a refetch (filter
// change, sort, etc.) — the full-page Spinner further down only covers the
// very first load, when there's nothing on screen yet to overlay.
const LoadingOverlay = () => (
  <div
    style={{
      position: "absolute",
      inset: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 10,
    }}
  >
    <Spinner />
  </div>
);

const LeadsMonitoringBody = ({
  selectedUser,
  showAllUsers,
  allUsersWithTickets,
  loading,
  kanbanFilter,
  setLoadMoreId,
  setTicketMetaData,
  departmentTicketCount,
}) => {
  // showAllUsers: selain sales — render every sales user and their leads as columns.
  if (showAllUsers) {
    if (loading && (!allUsersWithTickets || allUsersWithTickets.length === 0)) {
      return (
        <div className="text-center mt-4">
          <Spinner />
        </div>
      );
    }

    if (!allUsersWithTickets || allUsersWithTickets.length === 0) {
      return (
        <div className="text-center mt-4">
          <p className="text-muted">Tidak ada sales pada departemen ini.</p>
        </div>
      );
    }

    return (
      <div style={{ position: "relative" }}>
        {loading && <LoadingOverlay />}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 16,
            opacity: loading ? 0.5 : 1,
            pointerEvents: loading ? "none" : "auto",
          }}
        >
          {allUsersWithTickets.map((user, index) => (
            <div key={user.id || index}>
              <LeadsMonitoringLine
                index={index}
                user={user}
                kanbanFilter={kanbanFilter}
                setLoadMoreId={setLoadMoreId}
                setTicketMetaData={setTicketMetaData}
                departmentTicketCount={index === 0 ? departmentTicketCount : 0}
              />
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (loading && !selectedUser) {
    return (
      <div className="text-center mt-4">
        <Spinner />
      </div>
    );
  }

  if (!selectedUser) {
    return (
      <div className="text-center mt-4">
        <p className="text-muted">Pilih user untuk melihat leads.</p>
      </div>
    );
  }

  return (
    <div style={{ position: "relative" }}>
      {loading && <LoadingOverlay />}
      <div style={{ opacity: loading ? 0.5 : 1, pointerEvents: loading ? "none" : "auto" }}>
        <LeadsMonitoringLine
          index={0}
          user={selectedUser}
          kanbanFilter={kanbanFilter}
          setLoadMoreId={setLoadMoreId}
          setTicketMetaData={setTicketMetaData}
          departmentTicketCount={departmentTicketCount}
        />
      </div>
    </div>
  );
};

export default LeadsMonitoringBody;
